import React, { Component, Fragment } from 'react';
import { Translate } from '../../contexts/Language';
import { BreadCrumb, Card, Modal } from '../../components';
import { Config } from '../../config';
import { Service } from '../../services';
import { Button, Input, Label } from 'reactstrap';
import { ErrorMessage } from '../../components/Validator';


export class Settings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: false, disableModal: false,
            formData: {
                commissionRate: 0,
                depositManual: false,
                internalTransferManual: false,
                Tfastatus: false, // TFA statusü, 1 ise açık, 0 ise kapalı
                account: '',
                manualEntryKey: '',
                qrCodeSetupImageUrl: '',
                digitCode: '' // Kullanıcının gireceği doğrulama kodu
            },
            tfaConfirmValidation: {
                error: false,
                message: ""
            },
            tfaCancelValidation: {
                error: false,
                message: ""
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // Modal ilk kez açıldığında (kapalıydı ve şimdi açıldıysa) Generate2FA kodunu üret
        if (!prevState.modal && this.state.modal) {
            this.handleGenerateCode(); // Generate2FA fonksiyonunu çağır
        }
    }
    
    componentDidMount() {
        Config.utilities.loadingFetch();
        
        Service.User.GetTFAStatus().then(response =>{
            if (response) {
                this.setState(prevState => ({
                    formData: { 
                        ...prevState.formData,
                        Tfastatus: Boolean(response.tfastatus) 
                    },
                }));

            }
        } )
        Service.User.Settings().then(response => {
            if (response) {

                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        commissionRate : response.commissionRate,
                        depositManual: response.depositManual,
                        internalTransferManual:response.internalTransferManual,
                    }
                }));

            }

            Config.utilities.loadingFetch();
        });
    }

   
    handleGenerateCode = () => {
        Config.utilities.loadingFetch();
        Service.User.Generate2FA().then(response => {
            if (response && !response.error && response.data) {
                const { account, manualEntryKey, qrCodeSetupImageUrl } = response.data;
                this.setState(prevState => ({ 
                    formData: { 
                        ...prevState.formData,
                        account,
                        manualEntryKey,
                        qrCodeSetupImageUrl
                    }, 
                }));
            } else {
                console.error('TFA generation failed.');
            }
            Config.utilities.loadingFetch();
        }).catch(error => {
            console.error('Error generating TFA code:', error);
            Config.utilities.loadingFetch();
        });
    }

    handleVerifyCode = (e) => {
        e.preventDefault();
        const { digitCode } = this.state.formData;
        Config.utilities.loadingFetch();
        
        Service.User.Verify2FA({ DigitCode: digitCode }).then(response => {
            if (response && !response.error && response.dataVerify) {
                this.setState(prev=>({formData: { ...prev.formData,digitCode: '' },  tfaConfirmValidation:{error:false,message: ""}}))
                this.setState(prevState => ({
                    formData: { 
                        ...prevState.formData,
                        Tfastatus: true // Doğrulama başarılıysa TFA statusünü aç (1) yap
                    },
                    modal: false // Modalı kapat
                }));
            } 
            else {
                this.setState({tfaConfirmValidation:{error:true,message: "Wrong 2FA Code"}})
            }
            Config.utilities.loadingFetch();
        }).catch(error => {
            console.error('Error verifying TFA code:', error);
            Config.utilities.loadingFetch();
        });
    }

    handleDisableCode = (e) => {
        e.preventDefault();
        Config.utilities.loadingFetch();
        const { digitCode } = this.state.formData;
        Service.User.Verify2FA({ DigitCode: digitCode }).then(response => {
            if (response && !response.error && response.dataVerify) {
                this.setState(prev=>({formData: { ...prev.formData,digitCode: '' },tfaCancelValidation:{error:false,message: ""}}))
                this.setState(prevState => ({
                    formData: { 
                        ...prevState.formData,
                        Tfastatus: false 
                    },
                    disableModal: false // Modalı kapat
                }));
            } else {
                this.setState({tfaCancelValidation:{error:true,message: "Wrong 2FA Code"}})
            }
            Config.utilities.loadingFetch();
        }).catch(error => {
            console.error('Error verifying TFA code:', error);
            Config.utilities.loadingFetch();
        });
    }

    onSaveSettings() {

        Config.utilities.loadingFetch();

        Service.User.SaveSettings(this.state.formData).then(response => {

            Config.utilities.loadingFetch();

        });
    }
    onModal() {
        this.setState({
            modal: true
        });
    }
    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });
    }
    render() {
        return (
            <Fragment>
                
                   {this.state.modal && <Modal Title={Translate("TFA")} Show={this.state.modal}  onClose={(e) => this.setState(prev=>({formData: { ...prev.formData,digitCode: '' },tfaConfirmValidation: { error: false, message: "" }, modal: false  }))}>
                        <form onSubmit={this.handleVerifyCode}>
                    <div>
                        <h4>Generate 2FA</h4>
             
                        {/* Generate işleminden sonra gösterilecek bilgiler */}
                        {this.state.formData.account && (
                            <div>
                                <p>Manual Entry Key: {this.state.formData.manualEntryKey}</p>
                                <img src={this.state.formData.qrCodeSetupImageUrl} alt="QR Code" />
                            </div>
                        )}
                        
                        {/* Kod doğrulama kısmı */}
                        <ErrorMessage Validation={this.state.tfaConfirmValidation}  />
                        <div>
                            <label htmlFor="digitCode">Enter the code from your authenticator app:</label>
                            <input 
                                type="text" 
                                id="digitCode" 
                                name="digitCode"
                                required
                                minlength="6"
                                maxlength="6"
                                value={this.state.formData.digitCode}
                                onChange={(e) => this.onFormChange(e.target.value, "digitCode")} 
                            />
                        </div>
                        
                        {/* Verify butonu */}
                        <Button type='submit'>Verify 2FA Code</Button>
                    </div>
                    </form>
                </Modal>}

                    {this.state.disableModal && <Modal Title={Translate("TFA")} Show={this.state.disableModal}  onClose={(e) => this.setState(prev => ({formData: { ...prev.formData ,digitCode: '' },tfaCancelValidation: { error: false, message: "" }, disableModal: false }))}>
                    <form onSubmit={this.handleDisableCode}>

                            {/* Kod doğrulama kısmı */}
                            <ErrorMessage Validation={this.state.tfaCancelValidation}  />
                            <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                <Label htmlFor="digitCode">Enter the code from your authenticator app:</Label>
                                <Input 
                                    type="text" 
                                    id="digitCode" 
                                    name="digitCode" 
                                    required
                                    minlength="6"
                                    maxlength="6"
                                    value={this.state.formData.digitCode}
                                    onChange={(e) => this.onFormChange(e.target.value, "digitCode")} 
                                />
                            </div>
                            
                            {/* Verify butonu */}
                            <Button className='btn-primary' type="submit">Disable 2FA Code</Button>
                            </form>
                </Modal>}

                <BreadCrumb Title={Translate("Settings")} Name={Translate("Settings")} />
                <Card Title="Settings" Description="Customer panel settings">
                    
                    <div className="form-group row ml-1">
                        <label htmlFor="commissionRate" className="col-sm-2 col-form-label">BTC Commission Rate</label>
                        <div className="col-sm-4">
                            <input className="form-control" type="number" id="commissionRate" name="commissionRate" value={this.state.formData.commissionRate} onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                        </div>
                    </div>
                    <div className="form-group row ml-1">
                        <label htmlFor="depositManual" className="col-sm-2 col-form-label">Deposit Transfer Manual</label>
                        <div className="col-sm-4">
                            <input type="checkbox" id="depositManual" name="depositManual" switch="dark" checked={this.state.formData.depositManual} onChange={(e) => this.onFormChange(!this.state.formData.depositManual, "depositManual")} />
                            <label htmlFor="depositManual" data-on-label="On" data-off-label="Off" className="mt-2 mb-1"></label>
                        </div>
                    </div>
                    <div className="form-group row ml-1">
                        <label htmlFor="internalTransferManual" className="col-sm-2 col-form-label">Internal Transfer Manual</label>
                        <div className="col-sm-4">
                            <input type="checkbox" id="internalTransferManual" name="internalTransferManual" switch="dark" checked={this.state.formData.internalTransferManual} onChange={(e) => this.onFormChange(!this.state.formData.internalTransferManual, "internalTransferManual")} />
                            <label htmlFor="internalTransferManual" data-on-label="On" data-off-label="Off" className="mt-2 mb-1"></label>
                        </div>
                    </div>
                    <div className="form-group row ml-1 pt-3">
                        <label className="col-sm-2 col-form-label"></label>
                        <div className="col-sm-4">
                            <button type="button" className="btn btn-info" onClick={(e) => this.onSaveSettings()}><i className="far fa-save mr-1"></i> Save Settings</button>
                        </div>
                    </div>
                </Card>
                <Card Title="2FA" Description="Customer panel 2FA"><div className="form-group row ml-1">
                        <label htmlFor="TFA" className="col-sm-2 col-form-label">2FA</label>
                        <div className="col-sm-4">
                        <input 
                            type="checkbox" 
                            id="TFA" 
                            name="2FA" 
                            switch="dark" 
                            onChange={() => {!this.state.formData.Tfastatus ? this.setState({ modal: true }) : this.setState({ disableModal: true })}}
                            checked={Boolean(this.state.formData.Tfastatus)} 
                        />
                            <label htmlFor="TFA" data-on-label="On" data-off-label="Off" className="mt-2 mb-1"></label>
                        </div>
                    </div></Card>
            </Fragment>
        )
    }
}